import { createSelector } from 'reselect'
import { RootState } from '../index'

export const currentUserSelector = createSelector(
  (state: RootState) => state.user.user,
  (user) => user,
)

export const authStateSelector = createSelector(
  (state: RootState) => state.user.isAuthenticated,
  (isAuthenticated) => isAuthenticated,
)
